module.exports = __webpack_public_path__ + "img/image4.8e30ad2d.jpg";